// Fetch detailed product information by listing ID
export const fetchProductDetails = async (sdk, listingId) => {
  if (!listingId) {
    throw new Error('Listing ID is required to fetch product details.');
  }

  const response = await sdk.newSdk.listings.show({
    id: listingId,
    include: ['images'],
  });

  return response;
};

// Fetch availability time slots for a specific listing within a date range
export const fetchAvailabilityTimeSlots = async (sdk, { listingId, start, end }) => {
  if (!listingId) {
    throw new Error('Listing ID is required to fetch time slots.');
  }

  const timeSlotsApi = sdk.newSdk.timeSlots;

  if (!timeSlotsApi || typeof timeSlotsApi.query !== 'function') {
    throw new Error('SDK timeSlots API endpoint is not available.');
  }

  // start and end are strictly YYYY-MM-DD strings
  const response = await timeSlotsApi.query({
    listingId,
    start,
    end,
  });

  return response;
};